import React from 'react';
import {
  Box,
  Flex,
  Switch,
  Text,
  FormControl,
  FormErrorMessage,
} from '@chakra-ui/react';

interface AleaToggleProps {
  isChecked: boolean;
  onToggle: (e: React.ChangeEvent<HTMLInputElement>) => void;
  title: string;
  offTitle: string;
  description?: string;
  error?: string;
  size?: string;
  textSize?: string;
  isSingleLine?: boolean;
  disabled?: boolean;
}

const AleaToggle: React.FC<AleaToggleProps> = ({
  isChecked,
  onToggle,
  title,
  offTitle,
  description,
  error,
  size = 'lg',
  textSize = 'md',
  isSingleLine = true,
  disabled = false,
}) => {
  const textColor = 'black';
  return (
    <FormControl isInvalid={!!error}>
      <Flex align={isSingleLine ? 'center' : 'start'}>
        <Switch
          isChecked={isChecked}
          onChange={onToggle}
          colorScheme="green"
          mr={isSingleLine ? '17px' : '25px'}
          size={size}
          isDisabled={disabled}
          sx={{
            'span.chakra-switch__track:not([data-checked])': {
              backgroundColor: '#C6C6C6',
            },
            'span.chakra-switch__track[data-disabled]': {
              opacity: 0.4,
              cursor: 'not-allowed',
            },
          }}
        />
        <Box>
          <Text
            fontSize={textSize === 'lg' ? '20px' : '15px'}
            fontWeight={textSize === 'lg' ? '400' : '300'}
            color={textColor}
          >
            {isChecked ? title : offTitle}
          </Text>
          {description && (
            <Text
              fontSize="14px"
              color={textColor}
              mt="5px"
            >
              {description}
            </Text>
          )}
        </Box>
      </Flex>
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default AleaToggle;
